import { type ReactNode, useEffect } from 'react';

import { createPortal } from 'react-dom';

import { GlobalIcons, IconWarning_2 } from '@creditas-ui/react';
import { Typography } from '@creditas-ui/typography';
import { ScrollBox } from '../../base-components/scroll/Scroll';
import {
  IconWrapper,
  ModalBlind,
  ModalBox,
  ModalContainer,
  ModalHeader,
} from './modal.style';

type ModalProps = {
  canShow: boolean;
  children: ReactNode;
  hide: () => void;
  title: string;
};

export const Modal = ({ canShow, hide, children, title }: ModalProps) => {
  useEffect(() => {
    const keyHandler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        hide();
      }
    };
    if (canShow) {
      document.addEventListener('keydown', keyHandler);
    }
    return () => {
      document.removeEventListener('keydown', keyHandler);
    };
  }, [canShow, hide]);

  return canShow
    ? createPortal(
        <ModalContainer>
          <ModalBlind data-testid="blind-modal" onClick={hide} />
          <ModalBox isOpen={canShow}>
            <ModalHeader justifyContent="space-between">
              <Typography variant={'headingSmMedium'} color={'neutral.100'}>
                {title}
              </Typography>
              <IconWrapper data-testid="close-modal" onClick={hide}>
                <GlobalIcons
                  Icon={IconWarning_2}
                  size="medium"
                  data-testid="close-icon"
                />
              </IconWrapper>
            </ModalHeader>
            <ScrollBox>{children}</ScrollBox>
          </ModalBox>
        </ModalContainer>,
        document.body,
      )
    : null;
};
